module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "flex flex-column justify-center self-center center-ns mb4 main-container"
  }, [_c('akko-header', {
    staticClass: "header-responsive"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "flex responsive justify-center"
  }, [_c('div', {
    staticClass: "flex flex-column w-65 responsive-choose-plan items-center"
  }, [_c('select-upsell', {
    staticClass: "select-upsell",
    attrs: {
      "finishUpsell": _vm.finishUpsell,
      "productPrice": _vm.productPrice
    }
  })], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4681d648","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/upsell/UnifiedUpsell.vue
// module id = 1036
// module chunks = 0